import { getSelfPickupSiteList, removeBySiteId } from "@/libs/api";
export default {
	name: "pointList",
	data() {
		return {
			list: [],
		};
	},
	mounted() {
		this.$toast.loading({
			duration: 0,
			mask: true,
			message: "加载中...",
		});
		this.fetch();
	},
	methods: {
		fetch() {
			getSelfPickupSiteList({ clientCallType: "h5" })
				.then((res) => {
					if (res.code === "0000" || res.returnCode === "0000") {
						this.$toast.clear();
						this.list = res.data.result;
					} else {
						this.$toast.clear();
					}
				})
				.catch((error) => {
					this.$toast.clear();
				});
		},
		// 删除自提点
		deletePoint(item, index) {
			return (position, instance) => {
				switch (position) {
					case "left":
					case "cell":
					case "outside":
						instance.close();
						break;
					case "right":
						this.$dialog
							.confirm({
								message: "是否删除该自提点以及该自提点的核销员信息？",
							})
							.then(() => {
								removeBySiteId({ siteId: item.id, clientCallType: "h5" }).then((res) => {
									if (res.code === "0000" || res.returnCode === "0000") {
										this.list.splice(index, 1);
										instance.close();
										this.fetch();
									}
								});
							})
							.catch(() => {});
						break;
				}
				// this.$dialog
				// 	.confirm({
				// 		title: "提示",
				// 		message: "是否删除该自提点以及该自提点的核销员信息？",
				// 	})
				// 	.then(() => {
				// 		this.list.splice(index, 1);
				// 	})
				// 	.catch(() => {});
			};
		},
	},
};
